import React from 'react';
import MuiPagination from '@mui/material/Pagination';
import Box from '@mui/material/Box';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import Select, { SelectChangeEvent } from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';

interface PaginationProps {
  currentPage: number;
  totalPages: number;
  onPageChange: (page: number) => void;
  itemsPerPage?: number;
  itemsPerPageOptions?: readonly number[];
  onItemsPerPageChange?: (value: number) => void;
}

const Pagination: React.FC<PaginationProps> = ({ 
  currentPage, 
  totalPages, 
  onPageChange,
  itemsPerPage,
  itemsPerPageOptions,
  onItemsPerPageChange
}) => {
  const handleChange = (_event: React.ChangeEvent<unknown>, value: number) => {
    onPageChange(value);
  };

  const handleItemsPerPageChange = (event: SelectChangeEvent) => {
    onItemsPerPageChange?.(Number(event.target.value));
  };

  return (
    <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', mt: 3, gap: 2 }}>
      <MuiPagination
        count={totalPages}
        page={currentPage}
        onChange={handleChange}
        color="primary"
        size="large"
      />
      {itemsPerPage && itemsPerPageOptions && onItemsPerPageChange && (
        <FormControl size="small" sx={{ minWidth: 120 }}>
          <InputLabel id="items-per-page-label">Fincas por página</InputLabel>
          <Select
            labelId="items-per-page-label"
            value={String(itemsPerPage)}
            label="Fincas por página"
            onChange={handleItemsPerPageChange}
          >
            {itemsPerPageOptions.map(option => (
              <MenuItem key={option} value={option}>
                {option}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      )}
    </Box>
  );
};

export default Pagination; 